"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const StreamMessage_1 = __importDefault(require("./StreamMessage"));
const MessageRef_1 = __importDefault(require("./MessageRef"));
const MessageIDStrict_1 = __importDefault(require("./MessageIDStrict"));
const EncryptedGroupKey_1 = __importDefault(require("./EncryptedGroupKey"));
const Serializer_1 = require("../../Serializer");
const VERSION = 32;
class StreamMessageSerializerV32 extends Serializer_1.Serializer {
    toArray(streamMessage) {
        return [
            VERSION,
            streamMessage.messageId.toArray(),
            streamMessage.prevMsgRef ? streamMessage.prevMsgRef.toArray() : null,
            streamMessage.messageType,
            streamMessage.contentType,
            streamMessage.encryptionType,
            streamMessage.groupKeyId,
            streamMessage.serializedContent,
            streamMessage.newGroupKey ? streamMessage.newGroupKey.serialize() : null,
            streamMessage.signatureType,
            streamMessage.signature,
        ];
    }
    fromArray(arr) {
        const [version, // eslint-disable-line @typescript-eslint/no-unused-vars
        messageIdArr, prevMsgRefArr, messageType, contentType, encryptionType, groupKeyId, serializedContent, serializedNewGroupKey, signatureType, signature,] = arr;
        return new StreamMessage_1.default({
            messageId: MessageIDStrict_1.default.fromArray(messageIdArr),
            prevMsgRef: prevMsgRefArr ? MessageRef_1.default.fromArray(prevMsgRefArr) : null,
            content: serializedContent,
            messageType,
            contentType,
            encryptionType,
            groupKeyId,
            newGroupKey: serializedNewGroupKey ? EncryptedGroupKey_1.default.deserialize(serializedNewGroupKey) : null,
            signatureType,
            signature,
        });
    }
}
exports.default = StreamMessageSerializerV32;
StreamMessage_1.default.registerSerializer(VERSION, new StreamMessageSerializerV32());
//# sourceMappingURL=StreamMessageSerializerV32.js.map